//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myPersonalityAction from '../action/myPersonalityAction';
//Material-ui
import Button from '@material-ui/core/Button';
//Add
import IconCharacter from '../img/icon/icon_character.jpg';
//Part
import MenuMyProfile from './MenuMyProfile';
import PartPersonalityTable from './PartPersonalityTable';
import PartPersonalityImage from './PartPersonalityImage';
import PartPersonalityElement from './PartPersonalityElement';
import PartPersonalityRelationList from './PartPersonalityRelationList';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon


class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      type16: null,
      countEI: 0,
      countSN: 0,
      countTF: 0,
      countJP: 0,
      type: '',
      outline: '',
      element1: '',
      element2: '',
      element3: '',
      element4: '',
      element5: '',
      element6: '',
      element7: '',
      element8: '',
      relationsComment: '',
      lifeComment: '',
      jobComment: '',
      loveComment: '',
      relation: [],
      personalityDelDialogVisible: false,
    }
	}

  componentDidMount() {
    document.title = '性格診断 - パートナーズ';

  }

  _personalityDelSubmit() {
    this.props.myPersonalityDel();
  }

  render() {
    let personality = this.props.my.personality;

    if (personality.datetime === null) {
      return null;
    }
    else if (personality.type16) {
      return (
      <div>

        <div style={{maxWidth:'600px', margin:'auto'}}>

          <MenuMyProfile />

          <h1 align='center'>{personality.type16}タイプ</h1>
          <h2 align='center'>{personality.type}</h2>
          <h3 align='center'>{personality.outline}</h3>

          <div align='center'>
            <PartPersonalityImage
              type16={personality.type16}
              width={300}
            />
          </div>
        </div>


        <div style={{maxWidth:'400px', margin:'auto'}}>
          <PartPersonalityTable
            type16={personality.type16}
            countEI={personality.countEI}
            countSN={personality.countSN}
            countTF={personality.countTF}
            countJP={personality.countJP}
          />
          <PartPersonalityElement
            element1={personality.element1}
            element2={personality.element2}
            element3={personality.element3}
            element4={personality.element4}
            element5={personality.element5}
            element6={personality.element6}
            element7={personality.element7}
            element8={personality.element8}
          />


        </div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div style={{margin:'10px'}}>
            <h2>人間関係</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {personality.relationsComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>生活</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {personality.lifeComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>仕事</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {personality.jobComment}
            </div>
          </div>
          <div style={{margin:'10px'}}>
            <h2>恋愛</h2>
            <div style={{whiteSpace: 'pre-line'}}>
              {personality.loveComment}
            </div>
          </div>
        </div>

        <div style={{maxWidth:'600px', margin:'auto'}}>

          <h1 align='center'>{personality.type16}との相性</h1>
          <PartPersonalityRelationList
            relation={personality.relation}
          />
        </div>
        <div align='center' style={{margin:'15px'}}>
          <Button
            variant="outlined"
            onClick={ () => this.setState({personalityDelDialogVisible: true}) }
          >
            診断結果を削除する
          </Button>

          <DialogConfirm
            open={ this.state.personalityDelDialogVisible }
            title={'性格診断'}
            content={'性格診断を削除してもいいですか？'}
            apply={ () => this._personalityDelSubmit() }
            close={ () => this.setState({personalityDelDialogVisible: false}) }
          />

        </div>
      </div>
      )
    }
    else {
      return (
        <div>

          <div style={{maxWidth:'600px', margin:'auto'}}>

            <MenuMyProfile />

            <div style={{margin:'15px'}}>
              <h1 align='center'>性格診断を行っていません</h1>
            </div>

            <div align='center' style={{margin:'15px'}}>
              <img
                src={IconCharacter}
                style={{
                  maxWidth: '200px',
                  height: 'auto',
                  borderRadius: '50%',
                }}
                alt=''
              />
            </div>

            <div style={{maxWidth:'400px', margin:'auto'}}>
              <div style={{margin:'15px'}}>
                性格の骨格を作る4つの指向を計測することで、性格を分類するオリジナル性格診断です。<br/>
                「性格診断を行うとパートナーとの相性診断や性格の相性で検索が行えます」
              </div>
            </div>
            <div align='center' style={{margin:'15px'}}>
              <Button
                variant="contained"
                color="primary"
                style={{fontSize:'1.1em'}}
                onClick={ () => this.props.history.push('/my/personality/test28/') }
              >
                性格診断をする
              </Button>
            </div>
          </div>
        </div>
      )
    }
  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPersonalityAction
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
